export const vagasOptions = Array.from({ length: 11 }, (_, index) => ({
  value: index,
  label: `${index}`,
}));

interface FiltrosUnidadeBase {
  nome: string;
  isDataCriacao: boolean;
  dataInicio: Date | null;
  dataFim: Date | null;
  minhasIndicacoes: boolean | null;
  mobiliado: boolean | null;
  idRevendaEmpreendimento: string;
  idRevendaEmpreendimentoTorre: string;
  vagas: number | null;
  areaUtil: number | null;
  idRevendaRegiao: string;
  status: number[];
}

export interface FiltrosUnidade extends FiltrosUnidadeBase {
  metragemDe: string;
  metragemAte: string;
  valorDe: string;
  valorAte: string;
}

export interface FiltrosUnidadeEnvio extends FiltrosUnidadeBase {
  metragemDe: number | null;
  metragemAte: number | null;
  valorDe: number | null;
  valorAte: number | null;
}

const defaultFiltrosBase: FiltrosUnidadeBase = {
  nome: "",
  isDataCriacao: true,
  dataInicio: null,
  dataFim: null,
  minhasIndicacoes: null,
  mobiliado: null,
  idRevendaEmpreendimento: "",
  idRevendaEmpreendimentoTorre: "",
  vagas: null,
  areaUtil: null,
  idRevendaRegiao: "",
  status: [1, 2],
};

export const defaultFiltrosUnidade: FiltrosUnidade = {
  ...defaultFiltrosBase,
  metragemDe: "",
  metragemAte: "",
  valorDe: "",
  valorAte: "",
};

export const defaultFiltrosUnidadeEnvio: FiltrosUnidadeEnvio = {
  ...defaultFiltrosUnidade,
  metragemDe: null,
  metragemAte: null,
  valorDe: null,
  valorAte: null,
};
